// extracted by mini-css-extract-plugin
export var autoModal = "modal-module--autoModal--C1KQs";
export var closeButton = "modal-module--closeButton--+fj9Q";
export var content = "modal-module--content--rE4kM";
export var modal = "modal-module--modal--CImty";
export var sbShowMain = "modal-module--sb-show-main--F2BN2";